// ─── מודיעין שוק · reading and writing (sprint 20, stage 2) ─────────────────
//
// The clusters are shared (public.intel_clusters, written by the scheduled
// function); what this user has been shown is theirs (public.intel_seen, RLS:
// own rows only · migrations/sprint20_intel.sql). The ranking itself is in
// intelRank.js, on the device.
import { supabase } from "../lib/supabase";

const COLS = "id, symbol, event_type, title_he, what, unknown, articles, article_count, source_count, first_at, last_at, needs_summary, summarized_at, updated_at";

// Clusters of the given symbols, back to `days` (14: the open topics look two
// weeks back, the developments one). null on a failure, [] when there are none.
export async function fetchIntelClusters(symbols, { days = 14 } = {}) {
  const list = [...new Set((symbols || []).filter(Boolean))];
  if (!supabase || !list.length) return [];
  const since = new Date(Date.now() - days * 86400000).toISOString();
  const { data, error } = await supabase.from("intel_clusters").select(COLS)
    .in("symbol", list).gte("last_at", since).order("last_at", { ascending: false }).limit(500);
  if (error) {
    if (!/42P01|PGRST205/.test(String(error.code))) console.warn("[intel]", error.code, error.message);
    return null;
  }
  return data || [];
}

export async function fetchIntelSeen() {
  if (!supabase) return [];
  const since = new Date(Date.now() - 30 * 86400000).toISOString();
  const { data, error } = await supabase.from("intel_seen")
    .select("cluster_id, symbol, event_type, article_count, shown_at").gte("shown_at", since).order("shown_at", { ascending: false }).limit(1000);
  if (error) { console.warn("[intel seen]", error.code, error.message); return []; }
  return data || [];
}

// What was shown now. Upserted on (user_id, cluster_id): a card shown again
// after a new report gets its new count and time. user_id is the column's
// default (auth.uid()); RLS keeps it to the user's own rows.
export async function markIntelSeen(rows) {
  if (!supabase || !rows?.length) return;
  const { error } = await supabase.from("intel_seen").upsert(rows, { onConflict: "user_id,cluster_id" });
  if (error) console.warn("[intel seen write]", error.code, error.message);
}
